const duplicateBlockIdRules = (stylesheet, sourceBlockId, targetBlockId) => {
  Array.from(stylesheet.cssRules).forEach((rule) => {
    if (rule.selectorText.includes(sourceBlockId)) {
      const newSelector = rule.selectorText.replace(sourceBlockId, targetBlockId);
      stylesheet.insertRule(`${newSelector} { ${rule.style.cssText} }`, stylesheet.cssRules.length);
    }
  });
};

export default duplicateBlockIdRules;
